import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { UIGradient, UISectionDecoration } from '../../types';
import { Container } from '@gik/ui';

export interface IPageSectionProps extends React.HTMLAttributes<HTMLElement> {
  variant?: UIGradient | 'lightblue' | 'solid-neutral' | 'lightgray' | 'solid-neutral-100';
  gradientDarkening?: boolean;
  contained?: boolean;
  decoration?: UISectionDecoration;
  decorationPlacement?: 'left' | 'right' | 'both';
  noPad?: boolean;
  noPadBottom?: boolean;
  noPadTop?: boolean;
  asElement?: 'section' | 'div' | 'header';
  inset?: boolean;
}

// TODO create a story
export default function PageSection({
  children,
  className,
  variant,
  gradientDarkening,
  decoration,
  decorationPlacement = 'both',
  noPad,
  noPadBottom,
  noPadTop,
  contained = true,
  asElement = 'section',
  inset,
  ...otherProps
}: IPageSectionProps): React.ReactElement {
  const bem = bemBlock('page-section');
  const blockClasses = bem(
    null,
    [
      variant,
      { [`decoration-${decoration}`]: decoration },
      { [`decoration-${decorationPlacement}`]: decoration && decorationPlacement },
      { [`gradient-darkening`]: gradientDarkening },
      { [`no-pad`]: noPad },
      { [`no-pad-bottom`]: noPadBottom },
      { [`no-pad-top`]: noPadTop },
      { [`inset`]: inset },
    ],
    className
  );

  const Element = asElement;

  return (
    <Element className={blockClasses} {...otherProps}>
      {contained && <Container>{children}</Container>}
      {!contained && children}
    </Element>
  );
}
